"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDarkModeStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
/**
 * Use dark-mode selector to enable styles for dark mode.
 * @param styles css styles
 * @returns dark mode styles
 */
const getDarkModeStyles = function () {
  let styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    ["".concat(_utils.PREFERS_COLOR_SCHEME_DARK_SELECTOR, " &")]: styles
  };
};
exports.getDarkModeStyles = getDarkModeStyles;